/*
  Kviz lender (vl-kviz): ponašanje za sections/vl-kviz.liquid. Logika i tekstovi: landers-src/kviz/LOGIKA.md.

  1. Tok (9 do 11 pitanja): oblasti (do 3) → koliko dugo → ime → po jedno pitanje za svaku oblast →
     Nataša 1 → šta je probano → obroci → stres → cilj → Nataša 2 → godine → učitavanje → preporuka.
     Kviz je sloj preko cele strane, bez X-a: nazad vodi korak unazad (na prvom pitanju zatvara),
     telefonsko nazad zatvara (history.pushState pri otvaranju), Esc ne radi ništa.
  2. Bodovi: svaki odgovor daje bodove oblastima (SCORES). Oblast je aktivna sa 3+ boda; uzimaju se
     najviše 3, po bodovima (izjednačenje: redosled AREAS).
  3. Preporuka: od proizvoda čije su sve oblasti među aktivnim (bez sna) bira se onaj koji pokriva
     najviše oblasti, pa najviše bodova. San i nepokrivena oblast su kandidati za dodatak; ide jedan.
  4. Nataša: pasusi iz bloka (data-vl-kviz-text) biraju se po odgovorima; {ime}, {odgovor}, {cilj}
     se zamenjuju. Lični uvod na preporuci: šablon iz sekcije + "why" iz bloka proizvoda.
  5. Rapi i korpa kao u assets/vl-bn.js (količina iz izabrane trake, sopstveni submit, fioka).
  6. Merenje: dataLayer (vl_kviz_*), Clarity, atributi korpe "Kviz rezultat" / "Kviz odgovori".
     Ime se ne šalje nigde osim u tekst na strani.
*/
(function () {
  'use strict';

  if (window.__vlKvizLoaded) return;
  window.__vlKvizLoaded = true;

  var doc = document;

  var AREAS = ['stomak', 'slatko', 'ciklus', 'koza', 'san'];
  var AREA_ANSWER = { oblasti_a1: 'stomak', oblasti_a2: 'slatko', oblasti_a3: 'ciklus', oblasti_a4: 'koza', oblasti_a5: 'san' };

  var SCORES = {
    oblasti_a1: { stomak: 3 },
    oblasti_a2: { slatko: 3 },
    oblasti_a3: { ciklus: 3 },
    oblasti_a4: { koza: 3 },
    oblasti_a5: { san: 3 },

    stomak_a1: { stomak: 2 },
    stomak_a2: { stomak: 1 },
    stomak_a3: { stomak: 2 },
    stomak_a4: { stomak: 1, ciklus: 2 },

    slatko_a1: { slatko: 2 },
    slatko_a2: { slatko: 2 },
    slatko_a3: { slatko: 2 },
    slatko_a4: { slatko: 1, ciklus: 2 },

    ciklus_a1: { ciklus: 2 },
    ciklus_a2: { ciklus: 2, stomak: 1 },
    ciklus_a3: { ciklus: 2, san: 1 },
    ciklus_a4: { ciklus: 1 },

    koza_a1: { koza: 2 },
    koza_a2: { koza: 2 },
    koza_a3: { koza: 1 },
    koza_a4: { koza: 2 },

    san_a1: { san: 2 },
    san_a2: { san: 2 },
    san_a3: { san: 1, slatko: 1 },

    ritam_a1: { stomak: 1 },
    ritam_a2: { slatko: 1 },
    ritam_a3: { slatko: 1 },
    ritam_a4: {},

    stres_a1: {},
    stres_a2: {},
    stres_a3: { ciklus: 1, san: 1 },

    /* cilj je jak signal (Marko 15.10): sa još jednim znakom iz navika otvara oblast koja nije izabrana u 1. pitanju */
    cilj_a1: { stomak: 2 },
    cilj_a2: { slatko: 2 },
    cilj_a3: { ciklus: 2 },
    cilj_a4: { koza: 2 },
    cilj_a5: { san: 2 },
    cilj_a6: { slatko: 2 }
  };

  /* ključ rezultata → oblasti koje pokriva; redosled = prednost kod izjednačenja */
  var PRODUCTS = [
    ['ultimate-harmony-trio', ['ciklus', 'slatko', 'stomak']],
    ['total-vitality-trio', ['koza', 'ciklus', 'stomak']],
    ['daily-calm-duo', ['stomak', 'slatko']],
    ['hormone-duo', ['ciklus', 'slatko']],
    ['inner-harmony-duo', ['ciklus', 'stomak']],
    ['glow-and-flow-duo', ['koza', 'stomak']],
    ['whole-beauty-ritual-duo', ['koza', 'ciklus']],
    ['belly-support', ['stomak']],
    ['no-sweet-hero', ['slatko']],
    ['miss-zen', ['ciklus']],
    ['collagen-superior', ['koza']],
    ['sleep-mode', ['san']]
  ];

  var SINGLE = { stomak: 'belly-support', slatko: 'no-sweet-hero', ciklus: 'miss-zen', koza: 'collagen-superior', san: 'sleep-mode' };

  var THRESHOLD = 3;
  var MAX_AREAS = 3;

  /* redosled koraka; pitanja po oblasti ulaze posle "ime" */
  var FLOW_HEAD = ['oblasti', 'trajanje', 'ime'];
  var FLOW_TAIL = ['natasa_1', 'probano', 'ritam', 'stres', 'cilj', 'natasa_2', 'godine'];
  var NOT_QUESTIONS = ['intro', 'natasa_1', 'natasa_2', 'loading'];
  var EXCLUSIVE = { probano: 'probano_a5' };

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
  }
  function later(fn) { return window.setTimeout(fn, 16); }
  function ucfirst(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function lcfirst(s) { return s ? s.charAt(0).toLowerCase() + s.slice(1) : s; }

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mobileQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 1023px)') : null;

  function track(name, data) {
    var payload = { event: 'vl_kviz_' + name };
    if (data) for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) { /* bez GTM-a */ }
    if (typeof window.clarity === 'function') {
      try { window.clarity('event', 'kviz_' + name); } catch (e) { /* bez Clarity-ja */ }
    }
  }

  /* ------------------------------------------------------------ logika preporuke */

  function scoreAnswers(answers) {
    var score = {};
    AREAS.forEach(function (a) { score[a] = 0; });
    Object.keys(answers).forEach(function (step) {
      if (!Array.isArray(answers[step])) return;
      answers[step].forEach(function (id) {
        var add = SCORES[id] || {};
        Object.keys(add).forEach(function (a) { score[a] += add[a]; });
      });
    });
    return score;
  }

  function recommend(score, available) {
    var active = AREAS.filter(function (a) { return score[a] >= THRESHOLD; });
    active.sort(function (a, b) { return (score[b] - score[a]) || (AREAS.indexOf(a) - AREAS.indexOf(b)); });
    active = active.slice(0, MAX_AREAS);

    var core = active.filter(function (a) { return a !== 'san'; });
    var main = null;
    var covered = [];

    if (!core.length) {
      main = active.indexOf('san') !== -1 ? 'sleep-mode' : null;
      covered = main ? ['san'] : [];
    } else {
      var best = null;
      PRODUCTS.forEach(function (entry) {
        var key = entry[0];
        var areas = entry[1];
        if (key === 'sleep-mode' || !available[key]) return;
        var fits = areas.every(function (a) { return core.indexOf(a) !== -1; });
        if (!fits) return;
        var sum = areas.reduce(function (s, a) { return s + score[a]; }, 0);
        if (!best || areas.length > best.areas.length || (areas.length === best.areas.length && sum > best.sum)) {
          best = { key: key, areas: areas, sum: sum };
        }
      });
      if (best) { main = best.key; covered = best.areas; }
    }

    var extra = null;
    var extraScore = -1;
    active.forEach(function (a) {
      if (covered.indexOf(a) !== -1) return;
      var key = SINGLE[a];
      if (!available[key] || key === main) return;
      if (score[a] > extraScore) { extra = key; extraScore = score[a]; }
    });

    return { main: main, extra: extra, active: active };
  }

  /* ------------------------------------------------------------ cene i korpa (kao vl-bn) */

  function formatRsd(n) {
    var parts = Number(n).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1] + ' RSD';
  }

  function setMoney(el, text) {
    if (window.VilaMarketMoney && typeof window.VilaMarketMoney.setBaseText === 'function') {
      window.VilaMarketMoney.setBaseText(el, text);
    }
  }

  function unwrapLazyTemplates(markup) {
    if (window.lazyTemplateController && typeof window.lazyTemplateController.cleanHTMLWithTemplate === 'function') {
      return window.lazyTemplateController.cleanHTMLWithTemplate(markup);
    }
    return markup
      .replace(/<lazy-template[\s\S]*?<template>/g, '')
      .replace(/<\/template>[\s\S]*?<\/lazy-template>/g, '');
  }

  function refreshCartDrawer() {
    var drawer = doc.getElementById('cartDrawerSection');
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var markup = data['cart-drawer'];
        if (!markup) return;
        var parsed = new DOMParser().parseFromString(unwrapLazyTemplates(markup), 'text/html');
        var incoming = parsed.getElementById('cartDrawerSection');
        if (!incoming) return;
        if (window.scriptController && typeof window.scriptController.saveExternalResourcesFromContainer === 'function') {
          window.scriptController.saveExternalResourcesFromContainer(incoming);
        }
        drawer.innerHTML = incoming.innerHTML;
      })
      .catch(function () { /* neuspelo osvežavanje ne sme da spreči otvaranje */ });
  }

  function openCartDrawer() {
    var drawer = doc.getElementById('cartDrawerSection');
    var modal = drawer ? drawer.querySelector('details-modal') : null;
    if (!modal || typeof modal.open !== 'function') {
      window.location.href = '/cart';
      return;
    }
    modal.open();
    drawer.classList.add('show-cart-drawer');
  }

  function addToCart(body) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, body: json }; }); });
  }

  /* ------------------------------------------------------------ kviz */

  function initKviz(root) {
    if (!root || root.dataset.vlKvizInit === 'true') return;
    root.dataset.vlKvizInit = 'true';

    var designMode = !!(window.Shopify && window.Shopify.designMode);
    if (designMode) root.classList.add('is-design-mode');

    var stage = $('[data-vl-kviz-stage]', root);
    var result = $('[data-vl-kviz-result]', root);
    var overlay = $('[data-vl-kviz-overlay]', root);
    var scroller = $('[data-vl-kviz-scroller]', root);
    var countEl = $('[data-vl-kviz-count]', root);
    var barEl = $('[data-vl-kviz-bar]', root);
    var barFill = $('[data-vl-kviz-bar-fill]', root);
    var backBtn = overlay ? $('[data-vl-kviz-back]', overlay) : null;
    var startBtn = $('[data-vl-kviz-start]', root);
    var nameInput = $('[data-vl-kviz-name]', root);

    /*
      main#MainContent teme pravi stacking context (z-index 1 kao flex/grid dete), a header je z 10,
      pa bi sloj preko cele strane ostao ISPOD headera. Zato sloj živi direktno u body-ju;
      elementi su isti, samo upiti koji ga traže idu kroz `overlay`, ne kroz `root`.
    */
    if (overlay && overlay.parentNode !== doc.body) {
      $$('body > .vl-kviz__overlay').forEach(function (old) { if (old !== overlay) old.parentNode.removeChild(old); });
      doc.body.appendChild(overlay);
    }
    var scope = overlay || root;

    var steps = {};
    $$('[data-vl-kviz-step]', overlay || root).forEach(function (el) { steps[el.getAttribute('data-vl-kviz-step')] = el; });

    var panels = $$('[data-vl-kviz-panel]', root);
    var extras = $$('[data-vl-kviz-extra]', root);
    var available = {};
    panels.forEach(function (p) { available[p.getAttribute('data-vl-kviz-panel')] = true; });

    var stepLabel = root.getAttribute('data-step-label') || '{n} / {total}';

    var answers = {};
    var name = '';
    var path = ['intro'];
    var current = null;
    var shown = { main: null, extra: null };
    var isOpen = false;
    var pushed = false;
    var loadingTimer = null;

    function label(id) {
      var el = $('[data-vl-kviz-answer="' + id + '"] .vl-kviz__answer-label', scope);
      return el ? el.textContent.trim() : '';
    }

    function first(step) { return (answers[step] || [])[0] || ''; }

    function chosenAreas() {
      return (answers.oblasti || []).map(function (id) { return AREA_ANSWER[id]; }).filter(Boolean);
    }

    function questionPath() {
      var follow = AREAS.filter(function (a) { return chosenAreas().indexOf(a) !== -1 && steps[a]; });
      return ['intro'].concat(
        FLOW_HEAD.filter(function (s) { return !!steps[s]; }),
        follow,
        FLOW_TAIL.filter(function (s) { return !!steps[s]; })
      );
    }

    /* "{ime}, tekst" → bez imena ostaje "Tekst" */
    function fill(tpl, extra) {
      var s = String(tpl || '');
      if (name) s = s.split('{ime}').join(name);
      else {
        /* "{ime}, još…" → "Još…": reč posle izbačenog imena dobija veliko slovo */
        s = s.replace(/\{ime\},\s*(\S)/g, function (m, c) { return c.toUpperCase(); })
          .replace(/,\s*\{ime\}/g, '')
          .split('{ime}').join('');
        s = ucfirst(s.trim());
      }
      if (extra) Object.keys(extra).forEach(function (k) { s = s.split('{' + k + '}').join(extra[k]); });
      return s;
    }

    /* ---- napredak ---- */

    function renderProgress(stepName) {
      var flow = path.slice(1);
      var pct = stepName === 'loading' ? 100 : Math.max(6, Math.round((flow.indexOf(stepName) / flow.length) * 100));
      if (barFill) barFill.style.width = pct + '%';
      if (barEl) barEl.setAttribute('aria-valuenow', String(pct));
      if (!countEl) return;
      if (NOT_QUESTIONS.indexOf(stepName) !== -1) { countEl.textContent = ''; return; }
      var questions = path.filter(function (s) { return NOT_QUESTIONS.indexOf(s) === -1; });
      var n = questions.indexOf(stepName) + 1;
      countEl.textContent = stepName === 'oblasti' && !(answers.oblasti || []).length
        ? stepLabel.replace('{n}', '1').replace(/\s*\S*\s*\{total\}.*$/, '')
        : stepLabel.replace('{n}', String(n)).replace('{total}', String(questions.length));
    }

    function syncButtons(stepEl, stepName) {
      var chosen = answers[stepName] || [];
      $$('[data-vl-kviz-answer]', stepEl).forEach(function (btn) {
        btn.setAttribute('aria-pressed', chosen.indexOf(btn.getAttribute('data-vl-kviz-answer')) !== -1 ? 'true' : 'false');
      });
      var limit = parseInt(stepEl.getAttribute('data-multi'), 10) || 0;
      if (limit) {
        var full = chosen.length >= limit;
        var exclusive = EXCLUSIVE[stepName];
        var exclusiveOn = exclusive && chosen.indexOf(exclusive) !== -1;
        $$('[data-vl-kviz-answer]', stepEl).forEach(function (btn) {
          var id = btn.getAttribute('data-vl-kviz-answer');
          var is = chosen.indexOf(id) !== -1;
          btn.disabled = (full && !is) || (exclusiveOn && !is);
        });
        var next = $('[data-vl-kviz-next]', stepEl);
        if (next) next.disabled = !chosen.length;
      }
    }

    function show(stepName, opts) {
      opts = opts || {};
      var el = steps[stepName];
      if (!el) return;
      Object.keys(steps).forEach(function (k) { setHidden(steps[k], k !== stepName); });
      current = stepName;
      renderProgress(stepName);
      if (NOT_QUESTIONS.indexOf(stepName) === -1) syncButtons(el, stepName);
      if (stepName === 'natasa_1' || stepName === 'natasa_2') renderNatasa(el, stepName);
      setHidden(backBtn, stepName === 'loading');
      if (overlay) overlay.classList.toggle('is-loading', stepName === 'loading');
      if (!reduceMotion) {
        el.classList.remove('is-entering', 'is-entering-back');
        void el.offsetWidth;
        el.classList.add(opts.back ? 'is-entering-back' : 'is-entering');
      }
      if (scroller) scroller.scrollTop = 0;
      if (stepName === 'ime' && nameInput && !opts.back) {
        window.setTimeout(function () { try { nameInput.focus({ preventScroll: true }); } catch (e) { /* bez fokusa */ } }, 320);
      } else {
        var heading = $('.vl-kviz__question', el);
        if (heading) heading.focus({ preventScroll: true });
      }
    }

    /* ---- sloj preko cele strane ---- */

    function open() {
      if (!overlay) return;
      answers = {};
      name = '';
      if (nameInput) nameInput.value = '';
      path = questionPath();
      setHidden(overlay, false);
      isOpen = true;
      doc.documentElement.classList.add('vl-kviz-lock');
      if (!designMode) {
        try { window.history.pushState({ vlKviz: true }, '', window.location.href); pushed = true; } catch (e) { pushed = false; }
      }
      show('oblasti');
      queueSticky();
    }

    function close(mode) {
      if (!isOpen) return;
      isOpen = false;
      window.clearTimeout(loadingTimer);
      setHidden(overlay, true);
      doc.documentElement.classList.remove('vl-kviz-lock');
      if (mode === 'user') {
        if (pushed) { pushed = false; try { window.history.back(); } catch (e) { /* bez istorije */ } }
        if (startBtn) startBtn.focus({ preventScroll: true });
        track('zatvoren', { kviz_korak: current });
      } else {
        pushed = false;
      }
      queueSticky();
    }

    on(window, 'popstate', function () { if (isOpen) { pushed = false; close('pop'); } });

    function go(delta) {
      path = questionPath();
      var idx = path.indexOf(current) + delta;
      if (idx < 1) { close('user'); return; }
      if (idx >= path.length) { finish(); return; }
      show(path[idx], { back: delta < 0 });
    }

    /* ---- odgovori ---- */

    $$('[data-vl-kviz-answer]', scope).forEach(function (btn) {
      on(btn, 'click', function () {
        var stepEl = btn.closest('[data-vl-kviz-step]');
        var stepName = stepEl.getAttribute('data-vl-kviz-step');
        var id = btn.getAttribute('data-vl-kviz-answer');
        var limit = parseInt(stepEl.getAttribute('data-multi'), 10) || 0;
        var chosen = (answers[stepName] || []).slice();

        if (limit) {
          var at = chosen.indexOf(id);
          if (at !== -1) chosen.splice(at, 1);
          else if (id === EXCLUSIVE[stepName]) chosen = [id];
          else if (chosen.length < limit) chosen.push(id);
          var order = $$('[data-vl-kviz-answer]', stepEl).map(function (b) { return b.getAttribute('data-vl-kviz-answer'); });
          chosen.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
          answers[stepName] = chosen;
          syncButtons(stepEl, stepName);
          path = questionPath();
          renderProgress(stepName);
          return;
        }

        answers[stepName] = [id];
        syncButtons(stepEl, stepName);
        track('odgovor', { kviz_korak: stepName, kviz_odgovor: id });
        window.setTimeout(function () { if (current === stepName && isOpen) go(1); }, reduceMotion ? 0 : 280);
      });
    });

    $$('[data-vl-kviz-next]', scope).forEach(function (btn) {
      on(btn, 'click', function () {
        var stepEl = btn.closest('[data-vl-kviz-step]');
        var stepName = stepEl.getAttribute('data-vl-kviz-step');
        if (!(answers[stepName] || []).length) return;
        if (stepName === 'oblasti') {
          /* odgovori za oblasti koje više nisu izabrane ne smeju da nose bodove */
          AREAS.forEach(function (a) { if (chosenAreas().indexOf(a) === -1) delete answers[a]; });
        }
        track('odgovor', { kviz_korak: stepName, kviz_odgovor: answers[stepName].join(',') });
        go(1);
      });
    });

    /* ime: Enter ili Dalje; preskakanje ostavlja prazno ime */
    function cleanName(raw) {
      var s = String(raw || '').replace(/[<>{}\[\]"'`]/g, '').replace(/\s+/g, ' ').trim().slice(0, 30);
      return s ? ucfirst(s) : '';
    }
    function submitName(skip) {
      name = skip ? '' : cleanName(nameInput ? nameInput.value : '');
      answers.ime = name ? [name] : [];
      track('ime', { kviz_ime: name ? 'da' : 'ne' });
      go(1);
    }
    if (nameInput) {
      var nameNext = $('[data-vl-kviz-name-next]', scope);
      on(nameInput, 'input', function () { if (nameNext) nameNext.disabled = cleanName(nameInput.value).length < 2; });
      on(nameInput, 'keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); if (cleanName(nameInput.value).length >= 2) submitName(false); }
      });
      on(nameNext, 'click', function () { submitName(false); });
      on($('[data-vl-kviz-name-skip]', scope), 'click', function () { submitName(true); });
    }

    on(startBtn, 'click', function () { track('pocetak'); open(); });

    function openWithArea(area) {
      open();
      var id = null;
      Object.keys(AREA_ANSWER).forEach(function (k) { if (AREA_ANSWER[k] === area) id = k; });
      if (id && steps.oblasti && $('[data-vl-kviz-answer="' + id + '"]', scope)) {
        answers.oblasti = [id];
        syncButtons(steps.oblasti, 'oblasti');
        path = questionPath();
        renderProgress('oblasti');
      }
    }
    root.vlKvizOpen = openWithArea;

    on(backBtn, 'click', function () { go(-1); });

    $$('[data-vl-kviz-continue]', scope).forEach(function (btn) {
      on(btn, 'click', function () { track(current || 'natasa'); go(1); });
    });

    /* ---- Natašini preseci: naslov, odjek odgovora, pasusi po odgovorima ---- */

    function textOf(el, id) {
      var p = $('[data-vl-kviz-text="' + id + '"]', el);
      return p ? p.textContent.trim() : '';
    }

    function renderNatasa(el, stepName) {
      var title = $('[data-vl-kviz-tpl="title"]', el);
      var closing = $('[data-vl-kviz-tpl="closing"]', el);
      var echo = $('[data-vl-kviz-echo]', el);
      var paras = $('[data-vl-kviz-paras]', el);
      var cilj = label(first('cilj'));
      var list = [];
      var quotes = [];

      if (stepName === 'natasa_1') {
        var areas = chosenAreas();
        areas.forEach(function (a) {
          var answer = label(first(a));
          if (answer) quotes.push(answer);
          var t = textOf(el, 'p_' + a);
          /* odgovor ide u navodnicima kakav je na dugmetu, pa ostaje veliko slovo i na početku rečenice */
          if (t) list.push(fill(t, { odgovor: answer || '…' }));
        });
        if (areas.length > 1) { var combo = textOf(el, 'p_combo'); if (combo) list.push(fill(combo)); }
        if (first('trajanje') === 'trajanje_a3') { var yrs = textOf(el, 'p_godinama'); if (yrs) list.push(fill(yrs)); }
      } else {
        var probano = answers.probano || [];
        if (probano.some(function (id) { return id === 'probano_a1' || id === 'probano_a2' || id === 'probano_a3'; })) list.push(fill(textOf(el, 'p_probano_cajevi')));
        if (probano.indexOf('probano_a4') !== -1) list.push(fill(textOf(el, 'p_probano_suplementi')));
        if (probano.indexOf('probano_a5') !== -1) list.push(fill(textOf(el, 'p_probano_nista')));
        var ritam = first('ritam');
        if (ritam === 'ritam_a1') list.push(fill(textOf(el, 'p_ritam_trku')));
        if (ritam === 'ritam_a2' || ritam === 'ritam_a3') list.push(fill(textOf(el, 'p_ritam_kafa')));
        if (ritam === 'ritam_a4') list.push(fill(textOf(el, 'p_ritam_miru')));
        if (first('stres') === 'stres_a3') list.push(fill(textOf(el, 'p_stres')));
        [label(ritam), label(first('stres'))].forEach(function (q) { if (q) quotes.push(q); });
      }

      if (title) title.textContent = fill(textOf(el, 'title'), { cilj: lcfirst(cilj) || 'da ti bude lakše' });
      if (closing) closing.textContent = fill(textOf(el, 'closing'));
      if (echo) {
        echo.innerHTML = '';
        quotes.forEach(function (q) { var li = doc.createElement('li'); li.textContent = q; echo.appendChild(li); });
        setHidden(echo, !quotes.length);
      }
      if (paras) {
        paras.innerHTML = '';
        list.filter(Boolean).forEach(function (t) { var p = doc.createElement('p'); p.textContent = t; paras.appendChild(p); });
      }
    }

    /* ---- učitavanje pre preporuke: duže, redovi se štikliraju jedan po jedan ---- */

    function runLoading(done) {
      var items = $$('[data-vl-kviz-loading-item]', steps.loading || scope);
      var fillEl = $('[data-vl-kviz-loader-fill]', scope);
      var total = reduceMotion ? 800 : Math.max(5000, 1300 * items.length + 900);
      items.forEach(function (it) {
        it.classList.remove('is-done');
        var span = $('[data-vl-kviz-tpl="loading"]', it);
        if (span) {
          if (typeof span.dataset.tpl !== 'string') span.dataset.tpl = span.textContent;
          span.textContent = fill(span.dataset.tpl);
        }
      });
      if (fillEl) {
        fillEl.style.transition = 'none';
        fillEl.style.width = '0%';
        void fillEl.offsetWidth;
        fillEl.style.transition = 'width ' + total + 'ms linear';
        fillEl.style.width = '100%';
      }
      items.forEach(function (it, i) {
        window.setTimeout(function () { if (isOpen) it.classList.add('is-done'); }, Math.round(total * (i + 1) / (items.length + 1)));
      });
      loadingTimer = window.setTimeout(done, total + 300);
    }

    /* ---- rezultat ---- */

    function panelByKey(key) {
      for (var i = 0; i < panels.length; i++) if (panels[i].getAttribute('data-vl-kviz-panel') === key) return panels[i];
      return null;
    }

    function answerLabels() {
      var out = [];
      chosenAreas().forEach(function (a) { var l = label(first(a)); if (l) out.push(l); });
      ['ritam', 'stres', 'cilj'].forEach(function (s) { var l = label(first(s)); if (l) out.push(l); });
      return out;
    }

    function joinSr(items) {
      if (!items.length) return '';
      if (items.length === 1) return items[0];
      return items.slice(0, -1).join(', ') + ' i ' + items[items.length - 1];
    }

    function personalText(panel) {
      var tpl = root.getAttribute('data-personal') || '';
      var areas = chosenAreas().map(function (a) {
        var id = null;
        Object.keys(AREA_ANSWER).forEach(function (k) { if (AREA_ANSWER[k] === a) id = k; });
        return lcfirst(label(id));
      }).filter(Boolean);
      var trajanje = lcfirst(label(first('trajanje')));
      var cilj = lcfirst(label(first('cilj')));
      var why = panel.getAttribute('data-why') || '';
      var s = fill(tpl, { oblasti: joinSr(areas) || 'ono što te muči', trajanje: trajanje || 'već neko vreme', why: why, cilj: cilj || 'da ti bude lakše' });
      return s.replace(/\s{2,}/g, ' ').trim();
    }

    function pluralCount(n) {
      var mod10 = n % 10;
      var mod100 = n % 100;
      var key = 'many';
      if (mod10 === 1 && mod100 !== 11) key = 'one';
      else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) key = 'few';
      return n + ' ' + (root.getAttribute('data-count-' + key) || '');
    }

    function loadRating(panel) {
      var row = $('[data-vl-kviz-rating]', panel);
      if (!row || panel.dataset.vlKvizRating) return;
      panel.dataset.vlKvizRating = 'loading';
      if (!window.VPAliReviews || typeof window.VPAliReviews.fetchHistogram !== 'function') {
        panel.dataset.vlKvizRating = '';
        on(window, 'load', function () { if (!panel.dataset.vlKvizRating) loadRating(panel); });
        return;
      }
      window.VPAliReviews.fetchHistogram({ shopDomain: root.getAttribute('data-shop'), productId: panel.getAttribute('data-product-id') })
        .then(function (h) {
          panel.dataset.vlKvizRating = 'done';
          if (!h || !h.total) return;
          var text = $('[data-vl-kviz-rating-text]', row);
          if (text) text.textContent = Number(h.average).toFixed(1).replace('.', ',') + ' · ' + pluralCount(h.total);
          setHidden(row, false);
        })
        .catch(function () { panel.dataset.vlKvizRating = 'done'; });
    }

    function showResult(main, extra, opts) {
      opts = opts || {};
      var panel = panelByKey(main);
      if (!panel) return;
      shown = { main: main, extra: extra };

      panels.forEach(function (p) { setHidden(p, p !== panel); });
      extras.forEach(function (x) {
        var is = x.getAttribute('data-vl-kviz-extra') === extra;
        setHidden(x, !is);
        if (!is) return;
        var price = $('[data-vl-kviz-extra-price]', x);
        var cents = price ? parseInt(price.getAttribute('data-price'), 10) : 0;
        if (cents > 0) setMoney(price, formatRsd(cents / 100));

        /* dodatak stoji odmah ispod glavne kartice i kaže za koji problem iz odgovora je */
        var card = $('.vl-kviz__card', panel);
        if (card && card.nextSibling !== x) card.parentNode.insertBefore(x, card.nextSibling);
        var extraPanel = panelByKey(extra);
        var why = $('[data-vl-kviz-extra-why]', x);
        if (why) {
          why.textContent = extraPanel ? (extraPanel.getAttribute('data-why') || '') : '';
          setHidden(why, !why.textContent);
        }
        var echo = $('[data-vl-kviz-extra-echo]', x);
        if (echo) {
          echo.innerHTML = '';
          var area = null;
          Object.keys(SINGLE).forEach(function (a) { if (SINGLE[a] === extra) area = a; });
          var ids = [];
          Object.keys(AREA_ANSWER).forEach(function (k) { if (AREA_ANSWER[k] === area && (answers.oblasti || []).indexOf(k) !== -1) ids.push(k); });
          if (area) ids.push(first(area));
          ids.map(label).filter(Boolean).forEach(function (t) { var li = doc.createElement('li'); li.textContent = t; echo.appendChild(li); });
          setHidden(echo, !echo.children.length || !opts.fromQuiz);
        }
      });

      var productName = panel.getAttribute('data-name') || '';
      var title = $('[data-vl-kviz-result-title]', root);
      if (title) title.textContent = productName;
      var forEl = $('[data-vl-kviz-result-for]', root);
      if (forEl) {
        forEl.textContent = fill(root.getAttribute('data-result-for') || '');
        setHidden(forEl, !opts.fromQuiz);
      }

      var personal = $('[data-vl-kviz-personal]', root);
      var personalTextEl = $('[data-vl-kviz-personal-text]', root);
      if (personalTextEl) personalTextEl.textContent = opts.fromQuiz ? personalText(panel) : '';
      var labels = opts.fromQuiz ? answerLabels() : [];
      var said = $('[data-vl-kviz-said]', root);
      var list = $('[data-vl-kviz-said-list]', root);
      if (list) {
        list.innerHTML = '';
        labels.forEach(function (t) { var li = doc.createElement('li'); li.textContent = t; list.appendChild(li); });
      }
      setHidden(said, !labels.length);
      setHidden(personal, !opts.fromQuiz);

      var closingTitle = $('[data-vl-kviz-closing-title]', root);
      if (closingTitle) closingTitle.textContent = fill(root.getAttribute('data-closing-title') || '');

      setHidden(result, false);
      if (!designMode) setHidden(stage, !!opts.fromQuiz || !!opts.fromUrl);
      /* dok je preporuka na strani, deo ispod uvoda („Tri koraka") se sklanja (CSS) */
      doc.documentElement.classList.add('vl-kviz-result');

      var sticky = $('[data-vl-kviz-sticky-name]', root);
      if (sticky) sticky.textContent = productName;

      queuePass(panel);
      loadRating(panel);

      if (!opts.editor) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('rezultat', main);
          if (extra) url.searchParams.set('dodatak', extra); else url.searchParams.delete('dodatak');
          window.history.replaceState(null, '', url.toString());
        } catch (e) { /* stari pregledač */ }
      }

      if (opts.fromQuiz) {
        window.scrollTo(0, 0);
        var head = $('[data-vl-kviz-result-title]', root);
        if (head) window.setTimeout(function () { head.focus({ preventScroll: true }); }, reduceMotion ? 0 : 400);
        track('rezultat', { kviz_rezultat: main, kviz_dodatak: extra || '' });
        saveAttributes(productName, labels);
      }
      queueSticky();
    }

    function saveAttributes(productName, labels) {
      var age = label(first('godine'));
      var trajanje = label(first('trajanje'));
      var all = labels.concat(trajanje ? ['Traje: ' + trajanje] : [], age ? ['Godine: ' + age] : []);
      var body = JSON.stringify({ attributes: { 'Kviz rezultat': productName || '', 'Kviz odgovori': all.join(' | ') } });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .catch(function () { /* merenje ne sme da smeta kupovini */ });
    }

    function finish() {
      var score = scoreAnswers(answers);
      var rec = recommend(score, available);
      if (!rec.main) rec.main = 'daily-calm-duo';
      show('loading');
      runLoading(function () {
        close('done');
        showResult(rec.main, rec.extra, { fromQuiz: true });
      });
    }

    on($('[data-vl-kviz-retake]', root), 'click', function () {
      setHidden(result, true);
      setHidden(stage, false);
      doc.documentElement.classList.remove('vl-kviz-result');
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('rezultat');
        url.searchParams.delete('dodatak');
        window.history.replaceState(null, '', url.toString());
      } catch (e) { /* stari pregledač */ }
      window.scrollTo(0, 0);
      track('ponovo');
      open();
    });

    /* ---- Rapi: slot i izabrana traka (kao vl-bn) ---- */

    var SELECTED = 'vl-kviz-selected';
    var BUNDLE = '[class^="rapi-bundle-content"], [class*=" rapi-bundle-content"], .rapi-bundles';

    function barIndex(bar) {
      var input = bar.querySelector('input[type="radio"], input[type="checkbox"]');
      var m = input && /deal-(\d+)-/.exec(input.id || '');
      if (m) return parseInt(m[1], 10);
      var bars = bar.parentNode ? $$('.rapi-bundles__bar', bar.parentNode) : [];
      return bars.indexOf(bar);
    }

    function tierQuantity(panel, bar) {
      var idx = barIndex(bar);
      var bundle = window['rapi_bundle_' + panel.getAttribute('data-product-id')];
      var o = bundle && bundle.offers && bundle.offers[idx];
      if (o && parseInt(o.quantity, 10) > 0) return parseInt(o.quantity, 10);
      return [1, 2, 3, 6][idx] || null;
    }

    function selectedBar(panel, bars) {
      var i;
      for (i = 0; i < bars.length; i++) {
        var input = bars[i].querySelector('input[type="radio"], input[type="checkbox"]');
        if (input && input.checked) { panel.vlKvizLastBar = bars[i]; return bars[i]; }
      }
      for (i = 0; i < bars.length; i++) {
        var theirs = bars[i].className.split(SELECTED).join('');
        if (/selected|active|checked/i.test(theirs)) { panel.vlKvizLastBar = bars[i]; return bars[i]; }
      }
      if (panel.vlKvizLastBar && panel.contains(panel.vlKvizLastBar)) return panel.vlKvizLastBar;
      panel.vlKvizLastBar = bars[0] || null;
      return panel.vlKvizLastBar;
    }

    function pass(panel) {
      var slot = $('[data-vl-kviz-slot]', panel);
      if (!slot) return;
      var bundle = panel.querySelector(BUNDLE);
      if (bundle && !slot.contains(bundle)) slot.appendChild(bundle);
      var has = !!(bundle && slot.contains(bundle));
      slot.setAttribute('data-state', has ? 'filled' : 'empty');
      setHidden($('[data-vl-kviz-native]', panel), has);
      if (!has) return;
      var bars = $$('.rapi-bundles__bar', bundle);
      var sel = selectedBar(panel, bars);
      bars.forEach(function (bar) { bar.classList.toggle(SELECTED, bar === sel); });
      panel.vlKvizSelected = sel;
    }

    var pointerDown = false;
    var queued = [];
    var scheduled = false;

    function flush() {
      scheduled = false;
      if (pointerDown) return;
      var list = queued;
      queued = [];
      list.forEach(function (panel) {
        try { pass(panel); } catch (e) { if (window.console) console.error('[vl-kviz]', e); }
      });
    }

    function queuePass(panel) {
      if (queued.indexOf(panel) === -1) queued.push(panel);
      if (scheduled) return;
      scheduled = true;
      later(flush);
    }

    function releasePointer() {
      window.setTimeout(function () {
        pointerDown = false;
        if (queued.length && !scheduled) { scheduled = true; later(flush); }
      }, 0);
    }

    on(result, 'pointerdown', function () { pointerDown = true; }, true);
    on(doc, 'pointerup', releasePointer, true);
    on(doc, 'pointercancel', releasePointer, true);

    panels.forEach(function (panel) {
      new MutationObserver(function () { queuePass(panel); }).observe(panel, { childList: true, subtree: true });
      on(panel, 'change', function () { queuePass(panel); });
      on(panel, 'click', function (e) {
        if (e.target.closest && e.target.closest('.rapi-bundles__bar')) queuePass(panel);
      });
    });

    /* ---- dodaj u korpu / kupi odmah ---- */

    $$('form[data-vl-kviz-form]', root).forEach(function (form) {
      var panel = form.closest('[data-vl-kviz-panel]');
      var errorEl = panel ? $('[data-vl-kviz-error]', panel) : null;
      var lastSubmitter = null;

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        setHidden(errorEl, !message);
      }

      on(form, 'click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[type="submit"]') : null;
        if (t) lastSubmitter = t;
      });

      on(form, 'submit', function (e) {
        if (typeof window.fetch !== 'function') return;
        e.preventDefault();
        showError('');

        var submit = e.submitter || lastSubmitter || form.querySelector('[type="submit"]');
        var buyNow = !!(submit && submit.hasAttribute('data-vl-kviz-buy-now'));
        lastSubmitter = null;
        if (submit) {
          if (submit.getAttribute('aria-busy') === 'true') return;
          submit.setAttribute('aria-busy', 'true');
        }

        var payload = new FormData(form);
        var bar = panel ? panel.vlKvizSelected : null;
        var q = bar ? tierQuantity(panel, bar) : null;
        if (q) payload.set('quantity', String(q));

        addToCart(payload)
          .then(function (res) {
            if (!res.ok) {
              showError(res.body.description || res.body.message || 'Proizvod trenutno nije moguće dodati u korpu.');
              return;
            }
            track('korpa', { kviz_rezultat: panel ? panel.getAttribute('data-vl-kviz-panel') : '', kviz_kolicina: q || 1, kviz_kupi_odmah: buyNow });
            if (buyNow) {
              /* na vilapure.ba kapija prvo otvara EasySell, inače kasa */
              if (window.vilaCheckout) {
                Promise.resolve(window.vilaCheckout.go('/checkout')).then(function (opened) {
                  /* EasySell forma ostaje na strani: otključaj dugme da kupac može ponovo */
                  if (opened && submit) submit.removeAttribute('aria-busy');
                });
              } else {
                window.location.href = '/checkout';
              }
              return;
            }
            return refreshCartDrawer().then(openCartDrawer);
          })
          .catch(function () { form.submit(); })
          .then(function () { if (submit && !buyNow) submit.removeAttribute('aria-busy'); });
      });
    });

    /* ---- utisci: Prikaži još otvara sledeće poruke nadole ---- */

    var DM_STEP = 4;
    $$('[data-vl-kviz-dm-more]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var feed = btn.closest('[data-vl-kviz-dm-feed]');
        var hidden = $$('[data-vl-kviz-dm][hidden]', feed);
        hidden.slice(0, DM_STEP).forEach(function (fig) {
          setHidden(fig, false);
          if (!reduceMotion) {
            fig.classList.remove('is-revealing');
            void fig.offsetWidth;
            fig.classList.add('is-revealing');
          }
        });
        if (hidden.length <= DM_STEP) setHidden(btn, true);
        track('utisci', { kviz_rezultat: shown.main || '' });
      });
    });

    /* ---- dodatak: 1 komad ---- */

    $$('[data-vl-kviz-extra-add]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        if (btn.getAttribute('aria-busy') === 'true' || btn.disabled) return;
        btn.setAttribute('aria-busy', 'true');
        var body = new FormData();
        body.set('id', btn.getAttribute('data-variant-id'));
        body.set('quantity', '1');
        addToCart(body)
          .then(function (res) {
            if (!res.ok) return;
            btn.textContent = root.getAttribute('data-added-label') || btn.textContent;
            btn.disabled = true;
            track('dodatak', { kviz_dodatak: btn.closest('[data-vl-kviz-extra]').getAttribute('data-vl-kviz-extra') });
            return refreshCartDrawer().then(openCartDrawer);
          })
          .catch(function () { /* ostaje dugme za ponovni pokušaj */ })
          .then(function () { btn.removeAttribute('aria-busy'); });
      });
    });

    /* ---- sticky traka (telefon) ---- */

    var sticky = $('[data-vl-kviz-sticky]', root);
    var stickyShown = false;

    function setSticky(showIt) {
      if (!sticky || showIt === stickyShown) return;
      stickyShown = showIt;
      setHidden(sticky, !showIt);
      doc.body.style.paddingBottom = showIt ? sticky.getBoundingClientRect().height + 'px' : '';
    }

    function evaluateSticky() {
      if (!sticky || !mobileQuery || !mobileQuery.matches || result.hasAttribute('hidden') || isOpen) { setSticky(false); return; }
      var panel = shown.main ? panelByKey(shown.main) : null;
      var slot = panel ? $('[data-vl-kviz-slot]', panel) : null;
      var row = panel ? $('[data-vl-kviz-actions]', panel) : null;
      if (!row) { setSticky(false); return; }
      var top = (slot || row).getBoundingClientRect().top;
      var bottom = row.getBoundingClientRect().bottom;
      var inView = bottom > 0 && top < window.innerHeight;
      var past = result.getBoundingClientRect().top < 0;
      setSticky(!inView && past);
    }

    var stickyQueued = false;
    function queueSticky() {
      if (stickyQueued) return;
      stickyQueued = true;
      later(function () { stickyQueued = false; evaluateSticky(); });
    }

    on(window, 'scroll', queueSticky, { passive: true });
    on(window, 'resize', queueSticky);
    on($('[data-vl-kviz-sticky-cta]', root), 'click', function () {
      var panel = shown.main ? panelByKey(shown.main) : null;
      var slot = panel ? ($('[data-vl-kviz-slot]', panel) || $('[data-vl-kviz-actions]', panel)) : null;
      if (slot) window.scrollTo({ top: slot.getBoundingClientRect().top + window.pageYOffset - 120, behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    /* ---- editor teme: izbor bloka prikazuje taj korak ili rezultat ---- */

    on(doc, 'shopify:block:select', function (e) {
      var target = e.target;
      if (!target || !(root.contains(target) || (overlay && overlay.contains(target)))) return;
      var panel = target.closest('[data-vl-kviz-panel]');
      if (panel) {
        var key = panel.getAttribute('data-vl-kviz-panel');
        showResult(key, null, { editor: true });
        extras.forEach(function (x) { setHidden(x, x.getAttribute('data-vl-kviz-extra') !== key); });
        return;
      }
      var step = target.closest('[data-vl-kviz-step]');
      if (step && overlay && overlay.contains(step)) {
        setHidden(overlay, false);
        isOpen = true;
        path = questionPath();
        show(step.getAttribute('data-vl-kviz-step'));
      }
    });
    on(doc, 'shopify:block:deselect', function (e) {
      var target = e.target;
      if (target && overlay && overlay.contains(target)) { setHidden(overlay, true); isOpen = false; }
    });

    /* ---- start ---- */

    var params = null;
    try { params = new URL(window.location.href).searchParams; } catch (e) { params = null; }
    var fromUrl = params ? params.get('rezultat') : null;
    var extraFromUrl = params ? params.get('dodatak') : null;
    var openFromUrl = params ? params.get('kviz') === '1' : false;

    if (openFromUrl && !designMode) {
      var area = params.get('oblast') || '';
      try {
        var clean = new URL(window.location.href);
        clean.searchParams.delete('kviz');
        clean.searchParams.delete('oblast');
        window.history.replaceState(null, '', clean.toString());
      } catch (e) { /* stari pregledač */ }
      track('pocetak', { kviz_izvor: 'link' + (area ? ':' + area : '') });
      openWithArea(area);
    } else if (fromUrl && available[fromUrl]) {
      showResult(fromUrl, extraFromUrl && available[extraFromUrl] && extraFromUrl !== fromUrl ? extraFromUrl : null, { fromUrl: true });
    } else if (designMode && panels.length) {
      showResult(panels[0].getAttribute('data-vl-kviz-panel'), null, { editor: true });
    }
  }

  function initAll(scope) {
    $$('[data-vl-kviz]', scope).forEach(initKviz);
  }

  /*
    Dugmad i pločice izvan sekcije kviza (vl-kviz-info, kasnije blok na početnoj). Ako na strani
    nema kviza, klik ostaje običan link ka stranici kviza (?kviz=1), pa se kviz otvara tamo.
  */
  on(doc, 'click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-vl-kviz-open]') : null;
    if (!trigger) return;
    var quiz = $('[data-vl-kviz]');
    if (!quiz || typeof quiz.vlKvizOpen !== 'function') return;
    e.preventDefault();
    var area = trigger.getAttribute('data-vl-kviz-area') || '';
    track('pocetak', { kviz_izvor: area ? 'oblast:' + area : 'dugme' });
    quiz.vlKvizOpen(area);
  });

  if (doc.readyState === 'loading') {
    on(doc, 'DOMContentLoaded', function () { initAll(doc); });
  } else {
    initAll(doc);
  }

  on(doc, 'shopify:section:load', function (e) { initAll(e.target); });
})();
